import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import AnimatedChatComponent from '../pane/pane';
import {
  softwareEngineeringMessages,
  productManagementMessages,
  dsMessages,
  financeMessages
} from '../messages/messageData';
import chats from '../../asset/avatar/chat-s.MP4';
import chatf from '../../asset/avatar/chat-f.MP4';
import chatpm from '../../asset/avatar/chat-pm.MP4';
import chatds from '../../asset/avatar/chat-ds.MP4';
import './TabComponent.css';

const tabData = [
  { id: 'software', label: 'Software Engineering', messages: softwareEngineeringMessages, videoSrc: chats },
  { id: 'product', label: 'Product Management', messages: productManagementMessages, videoSrc: chatpm },
  { id: 'data', label: 'Data Science/ Machine Learning', messages: dsMessages, videoSrc: chatds },
  { id: 'finance', label: 'Financial Engineering', messages: financeMessages, videoSrc: chatf },
];

const FancyCustomTabComponent = ({ variant = 'default' }) => {
  const [activeTab, setActiveTab] = useState(tabData[0].id);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    setDropdownOpen(false);
  };

  return (
    <div className="tab-container">
      <div className="button-container">
        {tabData.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => handleTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="dropdown-container" onClick={() => setDropdownOpen(!dropdownOpen)}>
        <span>{tabData.find(tab => tab.id === activeTab).label}</span>
        <ChevronDown className={`dropdown-arrow ${dropdownOpen ? 'open' : ''}`} />
        {dropdownOpen && (
          <div className="dropdown-list">
            {tabData.map((tab) => (
              <div
                key={tab.id}
                className={`dropdown-item ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => handleTabChange(tab.id)}
              >
                {tab.label}
              </div>
            ))}
          </div>
        )}
      </div>
      <AnimatePresence mode="wait">
        <motion.div
          className="content-container"
          key={activeTab}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
        >
          <AnimatedChatComponent
            messages={tabData.find(tab => tab.id === activeTab).messages}
            videoSrc={tabData.find(tab => tab.id === activeTab).videoSrc}
            variant={variant}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default FancyCustomTabComponent;